import './assets/main.css'
import './assets/styles/mobile.css'
import './assets/styles/views/responsive.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import i18n from './i18n'

// Initialize dark mode immediately
import './composables/useDarkMode'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)

app.mount('#app')

// Prerender: dispatch event when router is ready
router.isReady().then(() => {
  document.dispatchEvent(new Event('render-event'))
})
